import FormNumberInput from "../../../components/FormNumberInput";

export const EmissionCase1_2 = ({ register, errors, setValidForm, getValues, t, watch, setValue,disabled }) => {
  return (
    <>
      <div className="col-12 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate1"
          name="customRate1"
          labelText={t("customRate")}
          disabled={disabled}
          rules={setValidForm("customRate1")}
          value={watch("customRate1")}
          onChange={(newValue) => setValue("customRate1", newValue)}
        />
        <div className="form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>

      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="carbonValue"
          name="carbonValue"
          labelText={t("carbon_content")}
          disabled={disabled}
          value={watch("carbonValue")}
          onChange={(newValue) => setValue("carbonValue", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue"
          name="gwpValue"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue")}
          onChange={(newValue) => setValue("gwpValue", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
    </>
  );
};

export const EmissionCase1_8 = ({ register, errors, setValidForm, getValues, t, watch, setValue ,disabled}) => {
  return (
    <>
      <div className="col-12 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate1"
          name="customRate1"
          labelText={t("customRate")}
          disabled={disabled}
          rules={setValidForm("customRate1")}
          value={watch("customRate1")}
          onChange={(newValue) => setValue("customRate1", newValue)}
        />
        <div className="form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>

      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gasRate2"
          name="gasRate2"
          labelText={t("bo")}
          disabled={disabled}
          value={watch("gasRate2")}
          onChange={(newValue) => setValue("gasRate2", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gasRate3"
          name="gasRate3"
          labelText={t("mcf")}
          disabled={disabled}
          value={watch("gasRate3")}
          onChange={(newValue) => setValue("gasRate3", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gasRate4"
          name="gasRate4"
          labelText={t("combustion")}
          disabled={disabled}
          value={watch("gasRate4")}
          onChange={(newValue) => setValue("gasRate4", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue"
          name="gwpValue"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue")}
          onChange={(newValue) => setValue("gwpValue", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
    </>
  );
};

export const EmissionCase1_10 = ({ register, errors, setValidForm, getValues, t, watch, setValue, disabled }) => {
  return (
    <>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate1"
          name="customRate1"
          labelText={t("gasDensity")}
          disabled={disabled}
          rules={setValidForm("customRate1")}
          value={watch("customRate1")}
          onChange={(newValue) => setValue("customRate1", newValue)}
        />
      </div>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="carbonValue0"
          name="carbonValue0"
          labelText={t("gasProportion")}
          disabled={disabled}
          value={watch("carbonValue0")}
          onChange={(newValue) => setValue("carbonValue0", newValue)}
        />
      </div>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue0"
          name="gwpValue0"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue0")}
          onChange={(newValue) => setValue("gwpValue0", newValue)}
        />
      </div>

      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate2"
          name="customRate2"
          labelText={t("gasDensity")}
          disabled={disabled}
          rules={setValidForm("customRate2")}
          value={watch("customRate2")}
          onChange={(newValue) => setValue("customRate2", newValue)}
        />
      </div>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="carbonValue1"
          name="carbonValue1"
          labelText={t("gasProportion")}
          disabled={disabled}
          value={watch("carbonValue1")}
          onChange={(newValue) => setValue("carbonValue1", newValue)}
        />
      </div>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue1"
          name="gwpValue1"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue1")}
          onChange={(newValue) => setValue("gwpValue1", newValue)}
        />
      </div>
    </>
  );
};

export const EmissionCase1_1 = ({ register, errors, setValidForm, getValues, t, watch, setValue, disabled }) => {
         return (
           <>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="customRate1"
                 name="customRate1"
                 labelText={t("customRate")}
                 disabled={disabled}
                 rules={setValidForm("customRate1")}
                 value={watch("customRate1")}
                 onChange={(newValue) => setValue("customRate1", newValue)}
               />
               <div className="form-label-has-top-space">
                 <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
               </div>
             </div>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="gwpValue0"
                 name="gwpValue0"
                 labelText={t("gasGwp")}
                 disabled={disabled}
                 value={watch("gwpValue0")}
                 onChange={(newValue) => setValue("gwpValue0", newValue)}
               />
               <div className="block lg:hidden form-label-has-top-space">
                 <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
               </div>
             </div>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="customRate2"
                 name="customRate2"
                 labelText={t("customRate")}
                 labelClass="block lg:hidden"
                 disabled={disabled}
                 rules={setValidForm("customRate2")}
                 value={watch("customRate2")}
                 onChange={(newValue) => setValue("customRate2", newValue)}
               />
               <div className="flex align-items-center ml-2">
                 <label htmlFor="customRate2">{getValues("gasRateUnit2")}</label>
               </div>
             </div>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="gwpValue1"
                 name="gwpValue1"
                 labelText={t("gasGwp")}
                 labelClass="block lg:hidden"
                 disabled={disabled}
                 value={watch("gwpValue1")}
                 onChange={(newValue) => setValue("gwpValue1", newValue)}
               />
               <div className="block lg:hidden form-label-has-top-space">
                 <label htmlFor="gasRateUnit2">{getValues("gasRateUnit2")}</label>
               </div>
             </div>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="customRate3"
                 name="customRate3"
                 labelText={t("customRate")}
                 labelClass="block lg:hidden"
                 disabled={disabled}
                 rules={setValidForm("customRate3")}
                 value={watch("customRate3")}
                 onChange={(newValue) => setValue("customRate3", newValue)}
               />
               <div className="flex align-items-center ml-2">
                 <label htmlFor="gasRateUnit3">{getValues("gasRateUnit3")}</label>
               </div>
             </div>
             <div className="col-12 lg:col-6 flex">
               <FormNumberInput
                 wrapperClass="w-full"
                 register={register}
                 errors={errors}
                 id="gwpValue2"
                 name="gwpValue2"
                 labelText={t("gasGwp")}
                 labelClass="block lg:hidden"
                 disabled={disabled}
                 value={watch("gwpValue2")}
                 onChange={(newValue) => setValue("gwpValue2", newValue)}
               />
               <div className="block lg:hidden form-label-has-top-space">
                 <label htmlFor="gasRateUnit3">{getValues("gasRateUnit3")}</label>
               </div>
             </div>
           </>
         );
       };

export const EmissionCase3711 = ({
  register,
  errors,
  setValidForm,
  t,
  getValues,
  detailCase = "",
  watch,
  setValue,
  disabled
}) => {
  return (
    <>
      {detailCase !== "1-11" && (
        <div className="col-12 lg:col-6 flex">
          <FormNumberInput
            wrapperClass="w-full"
            register={register}
            errors={errors}
            id="customRate1"
            name="customRate1"
            labelText={t("customRate")}
            disabled={disabled}
            rules={setValidForm("customRate1")}
            value={watch("customRate1")}
            onChange={(newValue) => setValue("customRate1", newValue)}
          />
          <div className="form-label-has-top-space">
            <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
          </div>
        </div>
      )}

      <div className="col-12 lg:col-6 flex">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue"
          name="gwpValue"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue")}
          onChange={(newValue) => setValue("gwpValue", newValue)}
        />
        <div className="block lg:hidden form-label-has-top-space">
          <label htmlFor="customRate1">{getValues("gasRateUnit1")}</label>
        </div>
      </div>
    </>
  );
};

// escape_rate 1-4 ; residue_rate 1-5 ; leak_rate 1-6
export const EmissionCase1_4_5_6 = ({ register, errors, setValidForm, t, customTitle, watch, setValue,disabled }) => {
  return (
    <>
      <div className="col-12 lg:col-6">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate1"
          name="customRate1"
          labelText={t(customTitle)}
          disabled={disabled}
          rules={setValidForm("customRate1")}
          value={watch("customRate1")}
          onChange={(newValue) => setValue("customRate1", newValue)}
        />
      </div>

      <div className="col-12 lg:col-6">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue"
          name="gwpValue"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue")}
          onChange={(newValue) => setValue("gwpValue", newValue)}
        />
      </div>
    </>
  );
};

export const EmissionCase1_9 = ({ register, errors, setValidForm, t, watch, setValue ,disabled}) => {
  return (
    <>
      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="customRate1"
          name="customRate1"
          labelText={t("gasDensity")}
          disabled={disabled}
          rules={setValidForm("customRate1")}
          value={watch("customRate1")}
          onChange={(newValue) => setValue("customRate1", newValue)}
        />
      </div>

      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="carbonValue"
          name="carbonValue"
          labelText={t("gasProportion")}
          disabled={disabled}
          value={watch("carbonValue")}
          onChange={(newValue) => setValue("carbonValue", newValue)}
        />
      </div>

      <div className="col-12 lg:col-4">
        <FormNumberInput
          wrapperClass="w-full"
          register={register}
          errors={errors}
          id="gwpValue"
          name="gwpValue"
          labelText={t("gasGwp")}
          disabled={disabled}
          value={watch("gwpValue")}
          onChange={(newValue) => setValue("gwpValue", newValue)}
        />
      </div>
    </>
  );
};
